/* eslint-disable */
import { UpdateOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import { addToChainBefore, ApiHandlerDiscreteParameter, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchCompleteCancelOrder } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/CancelOrder";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = { orderNumber: string };
type HandlerType = ApiHandlerDiscreteParameter<Parameter & HasOnSuccess, UpdateOrderApiParameter, OrderModel>;

export const ExecuteOnSuccessCallback: HandlerType = props => {
     props.parameter.onSuccess?.(); 
};
addToChainBefore(chain, DispatchCompleteCancelOrder, ExecuteOnSuccessCallback);